/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {submitBlocker} from '../api'

export const useMutationSubmitBlocker = createReactQueryMutationHook('submitBlocker', submitBlocker)
